module.exports = __webpack_public_path__ + "static/img/background.909495d0.svg";